import React from "react";
import { Typography, Tabs, Tab } from "@material-ui/core";
import styled from "styled-components";
import { ReportAlertsWidget } from "../../../widgets";
import { QualificationAlertsWidget } from "../../../widgets";
import { Divider } from "@material-ui/core";
import { connect } from "react-redux";
import { selectPermissions } from "./selectors";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";
const reducer = "AlertsPage_reducer";

const reportAlertsSelectors = ReportAlertsWidget.createSelectors(reducer);
const qualificationAlertsSelectors = QualificationAlertsWidget.createSelectors(
    reducer
);

const TabsBar = styled(Tabs)`
    border: 1px solid black;
    width: fit-content;
    border-radius: 10px;
    background-color: white;
`;

class Alerts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabVal: 0,
        };
    }
    render() {
        const { tabVal } = this.state;
        return (
            <>
                <StyledCard>
                    <StyledHeader>
                        <Typography variant="h5">Alerts</Typography>
                    </StyledHeader>
                    <StyledContent>
                        <TabsBar
                            indicatorColor="primary"
                            textColor="primary"
                            value={tabVal}
                            onChange={(event, value) => {
                                this.setState({ tabVal: value });
                            }}
                            style={{ borderWidth: 0 }}
                        >
                            <Tab label="Reports" />
                            <Tab
                                value="overview"
                                label="Qualification Alerts"
                            />
                        </TabsBar>
                        <br />
                        <Divider />
                        <StyledViewContainer>
                            {tabVal === 0 && (
                                <ReportAlertsWidget.view
                                    permissions={this.props.permissions}
                                    selectors={reportAlertsSelectors}
                                />
                            )}
                        </StyledViewContainer>
                        <StyledViewContainer>
                            {tabVal !== 0 && (
                                <QualificationAlertsWidget.view
                                    selectors={qualificationAlertsSelectors}
                                />
                            )}
                        </StyledViewContainer>
                    </StyledContent>
                </StyledCard>
            </>
        );
    }
}
export default connect((store) => {
    return {
        permissions: selectPermissions(store),
    };
}, {})(Alerts);
